module.exports = __webpack_public_path__ + "static/media/24UHCHR26.6afec9f5.jpg";